export default __webpack_public_path__ + "static/media/ic_usdc(w)_40.27f415ba.svg";